import { axios } from '../../services/axios';

/**
 * The saved SRT service profile for a wholesaler or partner.
 *
 * Mirrors the other platform-specific profile getters (Webex, 8x8, GCCH) —
 * the platform is a path segment and the trailing id is the owning
 * wholesaler/partner, not the profile id.
 *
 * @param {{ scope: string }} params `Partner/{partnerID}` or `Wholesaler/{wholesalerID}`.
 */
export default async function getSRTServiceProfile({ scope }) {
    const result = await axios.get(`/ServiceProfile/SRT/${scope}`);
    return result;
}
